import { Component, OnInit, Inject } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from 'angularfire2/storage';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {

  // Main task
  task: AngularFireUploadTask;

  // Progress monitoring
  percentage: Observable<number>;

  snapshot: Observable<any>;

  // Download URL
  downloadURL: Observable<string>;
  image: any;
  // State for dropzone CSS toggling
  isHovering: boolean;
  isVideo = false;
  isImage = false;

  constructor(public dialogRef: MatDialogRef<FileUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private storage: AngularFireStorage) { }


  onNoClick() {
    this.dialogRef.close(this.image);
  }
  toggleHover(event: boolean) {
    this.isHovering = event;
  }



  startUpload(event: FileList) {
    // The File object
    const file = event.item(0);

    // Client-side validation example
    if (file.type.split('/')[0] !== 'image' && file.type.split('/')[0] !== 'video' && file.type.split('/')[0] !== 'application') {
      console.error('unsupported file type :( ');
      console.log(file.type.split('/')[0]);
      return;
    }

    if (file.type.split('/')[0] === 'video') {
      this.isVideo = true;
    }
    if (file.type.split('/')[0] === 'image') {
      this.isImage = true;
    }


    // The storage path
    let path = `declaracao/`;
    if (this.isVideo) {
      path += 'videos/';
    } else if (this.isImage) {
      path += 'imagens/';
    } else {
      path += 'files/';
    }

    path += `${new Date().getTime()}_${file.name}`;


    // The main task
    this.task = this.storage.upload(path, file);
    const ref = this.storage.ref(path);

    // Progress monitoring
    this.percentage = this.task.percentageChanges();
    this.snapshot   = this.task.snapshotChanges();

    // The file's download URL
    this.task.snapshotChanges().pipe(finalize(() => {
      this.downloadURL = ref.getDownloadURL();
      this.downloadURL.subscribe(url => (this.image = url));
    })).subscribe();
    // this.downloadURL = this.task.downloadURL();
  }

  // Determines if the upload task is active
  isActive(snapshot) {
    return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes;
  }

}
